import React from "react";
import { GoogleScriptsProvider } from "./shared/GoogleScriptsContext";

const googleScriptsLibraries = ["places" as const];

export function withGoogleScriptsLibraries<P extends {}>(
  Component: React.ComponentType<P>
) {
  return (props: P) => (
    <GoogleScriptsProvider libraries={googleScriptsLibraries}>
      <Component {...props} />
    </GoogleScriptsProvider>
  );
}
